<!--  -->
<template>
  <div>
    <el-page-header class="page-header" @back="goBack" content="助力记录">
    </el-page-header>
    <div class="main">
      <el-table
        :data="tableData"
        style="margin-top: 2.0rem"
        border
        
      >
        <el-table-column prop="username" label="助力人">
          <template slot-scope="scope">
            <div class="userinfo">
              <el-image
                style="width: 4.2rem; height: 4.2rem; border-radius: .4rem"
                :src="scope.row.user_info.image"
                :preview-src-list="[scope.row.user_info.image]"
                fit="scale-down"
              ></el-image>
              <span style="margin-left: 1.0rem">{{
                scope.row.user_info.username
              }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="if_complete_name" label="任务状态">
        </el-table-column>
        <el-table-column prop="if_newUser_name" label="添加企业成员情况">
        </el-table-column>
        <el-table-column prop="createtime" label="参与时间" width="160">
        </el-table-column>
      </el-table>
      <div class="paging">
        <pagination
          :total="total"
          :page.sync="listQuery.page"
          :limit.sync="listQuery.limit"
          :page-sizes="[10,20,50,100]"
          :auto-scroll="false"
          @pagination="getList"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "fissionParticipate",
  components: {},

  data() {
    return {
      tableData: [],
      total: 0,
      listQuery: {
        page: 1,
        limit: 20,
      },
    };
  },

  computed: {},

  mounted() {
    this.getList();
  },

  methods: {
    goBack() {
      this.$router.go(-1);
    },
    onHistory() {},
    async getList() {
      const { data: res } = await this.axios({
        url: "/crm/ActivityFission/getParticipate",
        method: "POST",
        data: this.qs.stringify({
          usertoken: this.tooken.usertoken,
          account_id: this.tooken.account_id,
          phone: this.tooken.phone,
          page: this.listQuery.page,
          number_page:this.listQuery.limit,
          fission_id: this.$route.query.fission_id,
          card_user_id: this.$route.query.card_user_id,
        }),
      });
      if (res.code == 1) {
        this.tableData = res.data;
        this.total = res.count;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.userinfo {
  display: flex;
  align-items: center;
}
</style>